import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const HomeContext = React.createContext();

export const useHomeContext = () => useContext(HomeContext);

export function HomeProvider({ children }) {
  const [trendingCards, setTrendingCards] = useState([]);
  const [trendingHeading, setTrendingHeading] = useState({});
  const [articles, setArticles] = useState([]);
  const [reels, setReels] = useState({});
  const [exploreSidebar, setExploreSidebar] = useState({});

  useEffect(() => {
    fetchData
      .get('https://run.mocky.io/v3/7952429a-c6c1-4c32-9b49-ebc5ffa437a2')
      .then(setTrendingCards);
    fetchData
      .get('https://run.mocky.io/v3/e39665da-8d2b-42d0-98a0-95469c707b24')
      .then(setTrendingHeading);
    fetchData.get('https://run.mocky.io/v3/3637c61b-974e-417b-9a0f-26bd36035457').then(setArticles);
    fetchData.get('https://run.mocky.io/v3/be6f8178-a8ea-45f4-a0b0-a3e0a19a6662').then(setReels);
    fetchData
      .get('https://run.mocky.io/v3/bedfb734-2730-49f3-b179-877b66e8d366')
      .then(setExploreSidebar);
  }, []);

  const moreTrendingCards = () => {
    fetchData
      .get('https://run.mocky.io/v3/ec1a587f-c241-4e7e-84fc-33757d313e35')
      .then(data => setTrendingCards(prev => [...prev, ...data]));
  };

  const value = useMemo(
    () => ({
      trendingCards,
      trendingHeading,
      moreTrendingCards,
      articles,
      reels,
      exploreSidebar,
    }),
    [trendingCards, moreTrendingCards, trendingHeading, reels, articles, exploreSidebar]
  );

  return <HomeContext.Provider value={value}>{children}</HomeContext.Provider>;
}
